import { render, staticRenderFns } from "./mixed.vue?vue&type=template&id=21885f9a&scoped=true"
import script from "./mixed.vue?vue&type=script&lang=js"
export * from "./mixed.vue?vue&type=script&lang=js"
import style0 from "./mixed.vue?vue&type=style&index=0&id=21885f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21885f9a",
  null
  
)

export default component.exports